import { z } from 'zod';

import {
  CategoryCoverageDetail,
  ItemCounts,
  SceneCoverage,
  SceneItemView,
  SceneReviewProgress,
} from './scene-breakdown.js';
import { SceneTakeawaysView } from './scene-takeaways.js';

/**
 * ONE SCENE IN FULL — `GET …/script-versions/:v/breakdown-index/scenes/:sceneId`.
 *
 * The index (`BreakdownIndexView`) carries no text, items or evidence, so a 300-scene screenplay
 * opens on a light answer; the open scene is read here, alone (C8).
 */
export const SceneDetailView = z.object({
  scriptVersionId: z.string(),
  versionNumber: z.number().int().nullable(),
  scene: z.object({
    id: z.string(),
    ordinal: z.number().int(),
    sceneNumber: z.string().nullable(),
    slugline: z.string().nullable(),
    intExt: z.string().nullable(),
    timeOfDay: z.string().nullable(),
    pageEighths: z.number().int().nullable(),
    /** The scene's text as stored: what every evidence range indexes into. */
    text: z.string().nullable(),
    textSource: z.enum(['SCENE', 'MANUAL']).nullable(),
  }),
  /** 1-based, in script order, over live scenes. */
  position: z.object({ index: z.number().int(), total: z.number().int() }),
  progress: SceneReviewProgress,
  progressReason: z.string().nullable(),
  coverage: SceneCoverage,
  /** Every breakdown panel category, in panel order. */
  categories: z.array(CategoryCoverageDetail),
  items: z.array(SceneItemView),
  counts: ItemCounts,
  /** Null while the takeaways switch is off or no reading exists for the scene. */
  takeaways: SceneTakeawaysView.nullable(),
});
export type SceneDetailView = z.infer<typeof SceneDetailView>;
